import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import About from "../components/About";
import PracticeAreas from "../components/PracticeAreas";
import Attorneys from "../components/Attorneys";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import StickyConsultButton from "../components/StickyConsultButton";
import StructuredData, { firmSchema } from "../components/StructuredData";
import { ModalsProvider } from "../contexts/ModalsContext";
import { useContent } from "../contexts/ContentContext";
import { useSeo } from "../hooks/useSeo";
import SiteLoader from "../components/SiteLoader";
import SiteError from "../components/SiteError";

export default function HomePage() {
  const { firm, practiceAreas, attorneys, loading, error, refresh } = useContent();
  const { hash } = useLocation();
  useSeo({ path: "/" });

  useEffect(() => {
    if (loading) return;
    if (hash) {
      const el = document.querySelector(hash);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 50);
    }
    const els = document.querySelectorAll(".reveal");
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("in-view");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, [loading, hash]);

  if (loading) return <SiteLoader />;
  if (error || !firm) return <SiteError onRetry={refresh} />;

  return (
    <ModalsProvider>
      <Navbar />
      <main>
        <Hero />
        <About />
        <PracticeAreas />
        <Attorneys />
        <Contact />
      </main>
      <Footer />
      <StickyConsultButton />
      <StructuredData data={firmSchema(firm, attorneys, practiceAreas)} />
    </ModalsProvider>
  );
}
